export default[
    {
        path: '/dataList/collectRank',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '汇总排行',
            authLogin: true
        }
    }
]